<offline-notice>
</offline-notice>

<progress-overlay #progressOverlay>
</progress-overlay>

@if (productDesignerService.config) {
  <div class="pap-mat-primary productdesigner">
    <top-bar></top-bar>
    @if (!disableDesigner && currentProduct) {
      <div class="productdesigner-step">
        @switch (progress.group) {
          @case (progressConstants.GROUP_COLLAGEDESIGNER) {
            <collage-designer [designStepId]="progress.groupMember">
            </collage-designer>
          }
          @case (progressConstants.GROUP_FEATURES) {
            <feature-selection [featureGroupId]="progress.groupMember">
            </feature-selection>
          }
          @case (progressConstants.GROUP_ADDITIONAL_PRODUCTS) {
            <additional-products-selection></additional-products-selection>
          }
        }
      </div>
      <progress-buttons></progress-buttons>
    }
  </div>
}
<error></error>
